import GoogleTagManagerScript from 'app/components/scripts/GoogleTagManagerScript';
import MedalliaScript from 'app/components/scripts/MedalliaScript';
import PendoScript from 'app/components/scripts/PendoScript';

// Convenience component that includes all third-party scripts
export const ThirdPartyScripts = () => {
  return (
    <>
      <GoogleTagManagerScript />
      <MedalliaScript />
      <PendoScript />
    </>
  );
};
